// extracted by mini-css-extract-plugin
module.exports = {"vUiHueLight":"#eee","wrapper":"SortableHeader__wrapper___dPMNb","allowMultiline":"SortableHeader__allowMultiline___vkTgM","disabled":"SortableHeader__disabled___2++gZ"};